import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './PolicyPages.css';
import { Link } from 'react-router-dom';

const ShippingPolicy = () => {
  // Initialize AOS for scroll animations
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="policy-container" data-aos="fade-up">
      <header className="policy-header" data-aos="fade-down">
        <h1>Shipping Policy</h1>
        <p>Last updated: November 27, 2025</p>
      </header>

      <section className="policy-section" data-aos="fade-right">
        <h2>1. Shipping Partners</h2>
        <p><strong>Label Aadvi</strong> does not have its own delivery service. We partner with reliable third-party courier services to deliver your orders safely and efficiently. Our shipping partners are chosen for their track record of timely and secure deliveries.</p>
      </section>

      <section className="policy-section" data-aos="fade-left">
        <h2>2. Delivery Timeframe</h2>
        <p>Standard delivery times are estimated to be between 5-7 business days for orders within India. Please note that these are estimates and not guarantees. Delivery times may vary depending on your location and factors beyond our control, such as holidays, weather conditions, or carrier delays.</p>
      </section>

      <section className="policy-section" data-aos="fade-right">
        <h2>3. Shipping Costs</h2>
        <p>Shipping costs are calculated at checkout based on the weight of your order and your delivery location. The final shipping charge will be displayed on the checkout page before you complete your payment.</p>
      </section>

      <section className="policy-section" data-aos="fade-left">
        <h2>4. Order Tracking</h2>
        <p>Once your order is dispatched, you will receive a shipping confirmation email with a tracking number and a link to the courier's website. You can use this information to track the status of your delivery.</p>
      </section>

      <section className="policy-section" data-aos="fade-right">
        <h2>5. International Shipping</h2>
        <p>Currently, we only ship within India. We are working on expanding our services to other countries in the future.</p>
      </section>

      <section className="policy-section" data-aos="fade-up">
        <h2>6. Contact Us</h2>
        <p>If you have any questions about your order or our shipping policy, please do not hesitate to <Link to="/contact">contact us</Link>.</p>
      </section>
    </div>
  );
};

export default ShippingPolicy;
